import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

export default function Contact() {
  return (
    <section id="contact" data-testid="section-contact" className="relative py-28 md:py-36 overflow-hidden" style={{ background: "linear-gradient(180deg, rgba(255,179,71,0.22), rgba(255,75,62,0.14))" }}>
      <div className="orb w-[480px] h-[480px] bg-[#FFB347] blur-[140px] opacity-35 top-0 left-1/3" aria-hidden="true" />

      <div className="wrap relative">
        <Reveal>
          <p className="eyebrow text-[#FF4B3E] mb-12">On commence quand vous voulez</p>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-4">
          <Reveal>
            <div
              data-testid="contact-card-lieux"
              className="relative overflow-hidden rounded-[32px] min-h-[340px] p-9 md:p-12 flex flex-col gap-5 text-[#FFF6EE]"
              style={{ background: "linear-gradient(135deg, #D9815B 0%, #C96A45 50%, #A84E32 100%)" }}
            >
              <span aria-hidden="true" className="absolute -bottom-16 -right-4 font-serifit italic text-[11rem] leading-none text-white/15 select-none">
                a
              </span>
              <p className="eyebrow text-white/70">Établissements</p>
              <h3 className="font-display font-semibold text-3xl md:text-4xl max-w-[14ch]">
                Vos créneaux vides valent de l'or.
              </h3>
              <p className="text-white/85 font-medium max-w-[40ch] flex-grow">
                Temps creux, clientèle, image de marque. Parlons de ce qu'une programmation
                wellness peut activer chez vous.
              </p>
              <a
                href="mailto:alexia@ommymind.org?subject=Projet"
                data-testid="contact-cta-lieux"
                className="btn btn-acid self-start"
              >
                Nous écrire
                <ArrowUpRight size={16} />
              </a>
              <a href="tel:+33633341398" data-testid="contact-phone-lieux" className="font-mono2 text-sm text-white/85 hover:text-white transition-colors underline underline-offset-4">
                ou au 06 33 34 13 98
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.1}>
            <div
              data-testid="contact-card-pros"
              className="relative overflow-hidden rounded-[32px] min-h-[340px] p-9 md:p-12 flex flex-col gap-5 glass"
            >
              <span aria-hidden="true" className="absolute -bottom-16 -right-4 font-serifit italic text-[11rem] leading-none text-[#FF2A7A]/10 select-none">
                b
              </span>
              <p className="eyebrow text-[#FF4B3E]">Praticien·ne·s, coachs, thérapeutes</p>
              <h3 className="font-display font-semibold text-3xl md:text-4xl max-w-[16ch]">
                Votre talent mérite d'être placé au mieux.
              </h3>
              <p className="text-[#5F5258] font-medium max-w-[40ch] flex-grow">
                On vous met en relation avec des missions déjà qualifiées. Zéro démarchage,
                zéro paperasse, de manière pérenne.
              </p>
              <a
                href="mailto:alexia@ommymind.org?subject=Candidature%20r%C3%A9seau"
                data-testid="contact-cta-pros"
                className="btn btn-ink self-start"
              >
                Candidater
                <ArrowUpRight size={16} />
              </a>
              <a href="tel:+33633341398" data-testid="contact-phone-pros" className="font-mono2 text-sm text-[#5F5258] hover:text-[#E8431F] transition-colors underline underline-offset-4">
                ou au 06 33 34 13 98
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
